import React from 'react';
import { SectionInstance } from '../types';
import InlineEditText from '../InlineEditText';
import { sfHeadline, sfSub } from './sectionHelpers';

interface Props {
  section: SectionInstance;
}

const HeroCentered: React.FC<Props> = ({ section }) => {
  const c = section.controls;
  const variant = c.variant || section.variant || 'gradient_bg';

  const bgStyle: React.CSSProperties = {
    padding: '120px 24px',
    textAlign: 'center',
    position: 'relative',
  };

  if (variant === 'gradient_bg') {
    const gFrom = c.gradient_from || 'var(--brand-primary, #1a365d)';
    const gTo   = c.gradient_to   || 'var(--brand-secondary, #2563eb)';
    const gDir  = c.gradient_direction || '135deg';
    bgStyle.background = `linear-gradient(${gDir}, ${gFrom} 0%, ${gTo} 100%)`;
    bgStyle.color = '#fff';
  } else if (variant === 'image_bg' && c.background_image) {
    bgStyle.backgroundImage = `url(${c.background_image})`;
    bgStyle.backgroundSize = 'cover';
    bgStyle.backgroundPosition = 'center';
    bgStyle.color = '#fff';
  }

  return (
    <header className="sb-render sb-render-hero-centered" style={bgStyle}>
      {variant === 'image_bg' && c.background_image && (
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, rgba(0,0,0,0.6), rgba(0,0,0,0.3))' }} />
      )}
      <div style={{ position: 'relative', zIndex: 1, maxWidth: 800, margin: '0 auto' }}>
        {c.badge_text && (
          <span style={{
            display: 'inline-block',
            background: 'rgba(255,255,255,0.2)',
            padding: '6px 16px',
            borderRadius: 9999,
            fontSize: '0.875rem',
            fontWeight: 600,
            marginBottom: 16,
            backdropFilter: 'blur(8px)',
            border: '1px solid rgba(255,255,255,0.2)',
          }}>
            {c.badge_text}
          </span>
        )}
        <InlineEditText
          tag="h1"
          controlKey="headline"
          style={{ fontSize: '3.75rem', lineHeight: 1.1, marginBottom: 16, color: 'inherit', letterSpacing: '-0.025em', fontWeight: 800 }}
        >
          {sfHeadline(c, 'Your Headline Here')}
        </InlineEditText>
        {(sfSub(c) !== undefined ? sfSub(c) : true) && (
          <InlineEditText
            tag="p"
            controlKey="subheadline"
            style={{ fontSize: '1.25rem', opacity: 0.9, marginBottom: 32, maxWidth: 600, margin: '0 auto 32px' }}
          >
            {sfSub(c, 'Describe your value proposition here')}
          </InlineEditText>
        )}
        <div style={{ display: 'flex', gap: 16, justifyContent: 'center' }}>
          {c.cta_primary_text !== undefined || true ? (
            <a href={c.cta_primary_url || '#'} className="sb-cta-btn" style={{
              padding: '14px 32px', borderRadius: 'var(--brand-btn-radius, 6px)',
              background: variant === 'gradient_bg' ? '#fff' : 'var(--brand-primary, #1a365d)',
              color: variant === 'gradient_bg' ? 'var(--brand-primary, #1a365d)' : '#fff',
              fontWeight: 600, textDecoration: 'none',
              boxShadow: '0 4px 14px rgba(0,0,0,0.15)', transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            }}>
              <InlineEditText tag="span" controlKey="cta_primary_text">
                {c.cta_primary_text || 'Get Started'}
              </InlineEditText>
            </a>
          ) : null}
          {c.cta_secondary_text && (
            <a href={c.cta_secondary_url || '#'} style={{
              padding: '14px 32px', borderRadius: 'var(--brand-btn-radius, 6px)',
              background: 'transparent', border: '2px solid currentColor',
              color: 'inherit', fontWeight: 600, textDecoration: 'none',
            }}>
              {c.cta_secondary_text}
            </a>
          )}
        </div>
      </div>
    </header>
  );
};

export default HeroCentered;
